
import { useEffect, useState } from 'react';

const useOtpCountdown = (fromTime: Date | null, intervalSeconds: number) => {
  const [timeout, setTimeout] = useState(0);
  useEffect(() => {
    if (!fromTime) return;
    const timeNow = new Date();
    // @ts-ignore
    const timeSinceLastRequest = Math.ceil((timeNow - fromTime) / 1000);
    setTimeout(Math.max(intervalSeconds - timeSinceLastRequest, 0));
  }, [fromTime]);

  useEffect(() => {
    let otpCountdownInterval: any;
    if (timeout > 0) {
      otpCountdownInterval = setInterval(() => {
        setTimeout((old: number) => old - 1);
      }, 1000);
    }

    return () => {
      clearInterval(otpCountdownInterval);
    };
  }, [timeout]);

  return timeout;
};

export default useOtpCountdown;
